const api_url = "https://clairity-api-gmp5mt6sya-uc.a.run.app/clairity";

export default api_url;